import React, { ChangeEvent, useEffect, useRef } from "react";
import Button from "../Button/Button";
import ChatComponent from "../ChatComponent/ChatComponent";
import Tooltip from "../ToolTip/ToolTip";

interface ChatMessage {
  id: number;
  messageID: string;
  type: string;
  message: string;
  timestamp: string;
  sender_image_url?: string;
  sender_name?: string;
}

interface PrivateChatProps {
  msgID?: string;
  isEntityChat: boolean;
  figName: string;
  chatHistory: ChatMessage[];
  newMessage: string;
  onSendMessage?: () => void;
  onChange?: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  msgEnable: boolean;
  setNewMessage?: (value: string) => void; // <-- Add this prop
}

const PrivateChat: React.FC<PrivateChatProps> = ({
  msgID = "",
  isEntityChat,
  figName,
  chatHistory,
  newMessage,
  onSendMessage,
  onChange,
  msgEnable = false,
  setNewMessage,
}) => {
   //const textareaRef = useRef<HTMLTextAreaElement>(null);

  // Auto expand textarea based on content
  // const autoExpand = () => {
  //   const el = textareaRef.current;
  //   if (el) {
  //     el.style.height = "auto"; // Reset height
  //     el.style.height = `${el.scrollHeight}px`; // Set new height
  //   }
  // };

  // useEffect(() => {
  //   const el = textareaRef.current;
  //   if (el) {
  //     el.addEventListener("input", autoExpand);
  //     window.addEventListener("resize", autoExpand);
  //     autoExpand(); // Initial expansion

  //     return () => {
  //       el.removeEventListener("input", autoExpand);
  //       window.removeEventListener("resize", autoExpand);
  //     };
  //   }
  // }, []);

  // Scroll to the latest message or highlight a specific message
  const chatBoxRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (msgID) {
      const messageElement = document.getElementById(`msg-${msgID}`);
      if (messageElement) {
        messageElement.classList.add("msg-focus");
        chatBoxRef.current?.scrollTo({
          top: messageElement.offsetTop - chatBoxRef.current.offsetTop - 30,
          behavior: "smooth",
        });
        setTimeout(() => {
          messageElement.classList.remove("msg-focus");
        }, 2000);
      }
    } else {
      chatBoxRef.current?.scrollTo({
        top: chatBoxRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  }, [chatHistory, msgID]);

  // Handle Send Message
  const handleSendMessage = () => {
    if (onSendMessage) {
      onSendMessage(); // Send the message
    }
   if (setNewMessage) {setNewMessage("");} // Clear the input field
    // if (textareaRef.current) {
    //   textareaRef.current.style.height = "auto"; // Reset the height
    // }
  };

  return (
    <>
      <div ref={chatBoxRef} className="vertical-scroll mx-2">
        {chatHistory &&
          chatHistory.map((chat) => (
            <ChatComponent
              key={chat.id}
              id={chat.messageID}
              type={chat.type}
              name={chat?.sender_name}
              image={chat?.sender_image_url}
              timestamp={chat.timestamp}
              message={chat.message}
            />
          ))}
      </div>

      {/* Chat Input Section */}
      <div className="d-flex p-3 send-box w-100">
      <textarea
          // ref={textareaRef}
          placeholder="Start Typing..."
          className="ps-2 w-100 me-2 input-text-box"
          value={newMessage}
          onChange={(e) => {
            onChange && onChange(e);
            // autoExpand(); // Ensure it expands while typing
          }}
          disabled={!msgEnable}
        />
        {!msgEnable ? (
          <Tooltip
            text={
              isEntityChat
                ? `${figName} is not your current Fan1.`
                : `Become Fan1 to use the Message Board`
            }
            ClassName=""
          >
            <Button
              variant="primary"
              className="h-100 buy-button"
              label={<span className="mx-1">Send</span>}
              icon={<i className="fa-solid fa-paper-plane"></i>}
              disabled={true}
              onClick={() => {}}
            />
          </Tooltip>
        ) : (
          <Button
            variant="primary"
            className="w-25 buy-button"
            label={<span className="mx-1">Send</span>}
            icon={<i className="fa-solid fa-paper-plane"></i>}
            onClick={handleSendMessage} // Use the new function
          />
        )}
      </div>
    </>
  );
};

export default PrivateChat;
